import { env } from '@/env';

export function isExperimental() {
    return env.VUE_APP_ENABLE_EXPERIMENTAL_MODE === 'true';
}
